/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@material-ui/core";
import React, { useContext, useState } from "react";
import { useEffect } from "react";
import CircularProgressWithLabel from "../../../components/CircularProgressWithLabel";
import SingleSelect from "../../../components/SelectField/SingleSelect";
import { getFilterAppoinments } from "../../../services/apiservices/appoinments";
import styles from "../dashboard.module.scss";
import moment from "moment/moment";
import AuthContext from "../../../hooks/authContext";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

const Appointments = (props) => {
  const [progress, setProgress] = useState();
  const [frequency, setFrequency] = useState(
    moment().format(moment.HTML5_FMT.DATE)
  );
  const [totalappts, setTotalappts] = useState([]);
  const [completedappts, setCompletedAppts] = useState();
  const auth = useContext(AuthContext);
  const frequencyList = [
    { label: "Today", value: `${moment().format(moment.HTML5_FMT.DATE)}` },
    {
      label: "Yesterday",
      value: moment().subtract(1, "days").format(moment.HTML5_FMT.DATE),
    },
  ];
  const localClientID = localStorage.getItem('clientId');
  const localCompanyId = localStorage.getItem('companyId');
  const companyId = auth?.userProfile?.role === "Client" ? localCompanyId ? localCompanyId : auth?.userProfile?.companyId : auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const clientId = localClientID ? localClientID : auth?.userProfile?.client;
  const onChangeInput = (e) => {
    setFrequency(e.target.value);
  };
  const updateProgress = (newval) => {
    setProgress(newval);
  };

  useEffect(() => {
    const getdata = async () => {
      const resp = await getFilterAppoinments(frequency, frequency);
      const filtered = resp?.appointments?.filter(
        (appt) =>
          appt?.companyId === companyId &&
          (auth?.userProfile?.role !== "Client" || appt?.clientId === clientId)
      );

      const total = filtered?.length || 0;
      const completed = filtered?.filter((appt) => appt?.completed === true)?.length || 0;
      const progressVal = total ? (completed / total) * 100 : 0;

      setTotalappts(total);
      setCompletedAppts(completed);
      setProgress(progressVal);

    };

    getdata();
  }, [frequency]);

  return (
    <>
      <Grid item xs={12} sm={7} lg={12} className="mb-20">
        <div className="d-flex flex-center mb-10">
          <CalendarTodayIcon
            style={{
              color: "rgba(59, 130, 246, 1)",
            }}
          />
          <p className="p-0 m-0 ml-10 fonthe dark:text-white">Appointments</p>
        </div>
        <div style={{ marginBottom:"10px",width:"100%", border:"1px solid #E2E8F0"}}></div>
        <SingleSelect
          value={frequency}
          className={`field newonr`}
          name={"frequency"}
          onChange={(e) => onChangeInput(e)}
          options={frequencyList}
        />
      </Grid>

      <ul>
        <li className={styles.listItem2}>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={9} className="text-gray-500 dark:text-gray-100">
              Total {" "}
            </Grid>
            <Grid item xs={6} sm={3} className="text-right dark:text-[#94A3B8]">
              <strong>{totalappts}</strong>
            </Grid>
          </Grid>
        </li>
        <li className={styles.listItem2}>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={9} className="text-gray-500 dark:text-gray-100">
              Pending
            </Grid>
            <Grid item xs={6} sm={3} className="text-right dark:text-[#94A3B8]">
              <strong>{totalappts - completedappts}</strong>
            </Grid>
          </Grid>
        </li>
        <li className={styles.listItem2}>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={9} className="text-gray-500 dark:text-gray-100">
              Completed
            </Grid>
            <Grid item xs={6} sm={3} className="text-right dark:text-[#94A3B8]">
              <strong>{completedappts}</strong>
            </Grid>
          </Grid>
        </li>
      </ul>

      <Grid item xs={12} sm={5} lg={12} className="text-right mt-10">
        <CircularProgressWithLabel
          signt={"yes"}
          value={isNaN(progress) ? 0 : progress}
          wrapclass="#2b6823"
          title={"Progress"}
        />
      </Grid>
    </>
  );
};
export default Appointments;
